import React from 'react';

var Input = function Input(props) {
  return /*#__PURE__*/React.createElement("div", {
    className: "form-row input"
  }, props.label ? /*#__PURE__*/React.createElement("label", {
    htmlFor: props.name
  }, props.label) : '', props.maxLength != null ? /*#__PURE__*/React.createElement("input", {
    type: props.type,
    id: props.name,
    onChange: props.onChange,
    placeholder: props.placeholder,
    className: props["class"],
    value: props.value,
    name: props.name,
    onKeyDown: props.onKeyDown,
    maxLength: props.maxLength
  }) : /*#__PURE__*/React.createElement("input", {
    type: props.type,
    id: props.name,
    onChange: props.onChange,
    placeholder: props.placeholder,
    className: props["class"],
    value: props.value,
    name: props.name,
    onKeyDown: props.onKeyDown
  }));
};

export default Input;